module.exports = __webpack_public_path__ + "img/1_wind.818bf48f.jpg";